/**
 * Feature flag utilities for dashboard version switching
 *
 * Toggle in browser console:
 *   localStorage.setItem('tnx_dashboard_version', 'A') // Sankey chart
 *   localStorage.setItem('tnx_dashboard_version', 'B') // Actionable tables
 */

export type DashboardVersion = 'A' | 'B'

/**
 * Gets the current dashboard version from localStorage or env var
 * Priority: localStorage > env var > default ('B')
 */
export function getDashboardVersion(): DashboardVersion {
  // Check environment variable first
  const env = import.meta.env.VITE_DASHBOARD_VERSION
  if (env === 'A' || env === 'B') return env

  // Check localStorage
  if (typeof window !== 'undefined') {
    const stored = localStorage.getItem('tnx_dashboard_version')
    if (stored === 'A' || stored === 'B') return stored
  }

  // Default to new version
  return 'B'
}

/**
 * React hook for dashboard version
 * Note: This is a simple getter, not reactive. Reload page after changing localStorage.
 */
export function useDashboardVersion(): DashboardVersion {
  return getDashboardVersion()
}
